import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { DialogState } from '../models/DialogState';

export const REMOVE_BOOKMARK = 'REMOVE_BOOKMARK';

export class RemoveBookmarkAction implements IDialogAction {
    public readonly type = REMOVE_BOOKMARK;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(): any {
        if(this._service) {
            this._service.setReadLater(this.payload.id, false);
        }
        return;
    }
    public reducer(state: DialogState): DialogState {
        state.feed.messages.filter(m => m.id === this.payload.id).forEach(m => { m.readItLater = false; });
        return state;
    }
}

export const RemoveBookmarkActionTypeMapping = {
    [REMOVE_BOOKMARK]: RemoveBookmarkAction
};